import { gql } from '@apollo/client';

export const postPaquetesBancaIndividuoSP = gql`
mutation PaquetesBancaIndividuoSPApiRQ{
    PaquetesBancaIndividuoSPApiRQ(input: $input)  
        @rest(type: "PaquetesBancaIndividuoSPApiRS", path: "/api/gateway/formularios/PaqueteIndividuos", method: "POST"){
            nroSolicitud
            nroSecuencia
            resultado
            error
            stackTrace
        }
}
`